var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    {
      attrs: { show: _vm.show },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "CabeceraModal",
        { attrs: { titulo: "Editar" }, on: { cerrar: _vm.closeModal } },
        [
          _c(
            "div",
            {
              staticClass: "numero_sim",
              staticStyle: {
                "letter-spacing": "0.02em",
                "white-space": "nowrap",
                overflow: "hidden",
                "text-overflow": "ellipsis",
                "margin-top": "16px"
              }
            },
            [
              _c("div", {
                staticClass: "boton_crear",
                staticStyle: { height: "37px" }
              })
            ]
          )
        ]
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Detalle")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c(
            "div",
            { staticClass: "orden_compra", attrs: { align: "center" } },
            [
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" }
                        },
                        [
                          _c("v-container", { attrs: { "grid-list-md": "" } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "gridcard2 rounded-card2 orden_compra2"
                              },
                              [
                                _c(
                                  "FormFieldsContainer",
                                  { attrs: { titulo: "Editar" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { sm3: "", md3: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "prepend-icon": "car",
                                            color: "primary",
                                            label: "Código vehículo",
                                            disabled: "true"
                                          },
                                          model: {
                                            value: _vm.model_id_vehiculo,
                                            callback: function($$v) {
                                              _vm.model_id_vehiculo = $$v
                                            },
                                            expression: "model_id_vehiculo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      { attrs: { sm3: "", md3: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "prepend-icon": "car",
                                            color: "primary",
                                            label: "Patente",
                                            disabled: "true"
                                          },
                                          model: {
                                            value: _vm.model_patente,
                                            callback: function($$v) {
                                              _vm.model_patente = $$v
                                            },
                                            expression: "model_patente"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      { attrs: { sm3: "", md3: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "prepend-icon": "car",
                                            color: "primary",
                                            label: "Flota",
                                            disabled: "true"
                                          },
                                          model: {
                                            value: _vm.model_nomflota,
                                            callback: function($$v) {
                                              _vm.model_nomflota = $$v
                                            },
                                            expression: "model_nomflota"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      { attrs: { sm3: "", md3: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "prepend-icon": "car",
                                            color: "primary",
                                            label: "Grupo vehículo",
                                            disabled: "true"
                                          },
                                          model: {
                                            value: _vm.model_nomgrupovehiculo,
                                            callback: function($$v) {
                                              _vm.model_nomgrupovehiculo = $$v
                                            },
                                            expression: "model_nomgrupovehiculo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      { attrs: { sm3: "", md3: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "prepend-icon": "car",
                                            color: "primary",
                                            label: "Login Code"
                                          },
                                          model: {
                                            value: _vm.model_login_code,
                                            callback: function($$v) {
                                              _vm.model_login_code = $$v
                                            },
                                            expression: "model_login_code"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-flex",
                                      { attrs: { sm3: "", md3: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "prepend-icon": "car",
                                            color: "primary",
                                            label: "Plataforma",
                                            disabled: "true"
                                          },
                                          model: {
                                            value: _vm.PLATAFORMA,
                                            callback: function($$v) {
                                              _vm.PLATAFORMA = $$v
                                            },
                                            expression: "PLATAFORMA"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._l([1, 2, 3, 4, 5], function(ind) {
                                      return _c("v-flex", {
                                        key: ind,
                                        attrs: { sm3: "", md3: "" }
                                      })
                                    }),
                                    _c(
                                      "v-flex",
                                      { attrs: { sm3: "", md3: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "btn-crear v-btn theme--light",
                                            on: {
                                              click: _vm.start_update_logincode
                                            }
                                          },
                                          [_vm._v("Actualizar")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.mostrarModalCONFIRMAR,
          titulo: _vm.$t("Confirmación"),
          mensaje: _vm.Modal_confirmar_TEXTO,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }